import { clsx, type ClassValue } from "clsx";
import { t } from "i18next";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const userInitials = (username: string) => {
  const name = username?.split(' ');

  if (!name || name.length < 1) {
    return '';
  }

  const firstNameInitial = name[0].charAt(0).toUpperCase();

  if (name.length === 1) {
    return firstNameInitial;
  }

  const lastNameInitial = name[name.length - 1].charAt(0).toUpperCase();
  return `${firstNameInitial}${lastNameInitial}`;
};

export const cpfMask = (value: string) => {
  const numericOnly = value?.replace(/\D/g, '');

  return numericOnly
    ?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    .substring(0, 14);
};

export const cnpjMask = (value: string) => {
  const numericOnly = value?.replace(/\D/g, '');

  return numericOnly
    ?.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
    .substring(0, 18);
};

export function formatDateToMonthYear(dateString: string): string {
  const date = new Date(dateString);

  return date.toLocaleString('pt', { year: 'numeric', month: 'short' });
}

export function formatDate(date: Date | any): string {
  if (date.includes('T')) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  return date;
}

export function getOfferTypeLabel(type: string): string {
  switch (type) {
    case "principal":
      return t("sales:offer_type.principal");
    case "offer_bump":
      return t("sales:offer_type.order_bump");
    case "up_sell":
      return t("sales:offer_type.upsell");
    case "down_sell":
      return t("sales:offer_type.downsell");
    default:
      return t("sales:offer_type.unknown");
  }
}